/* eslint-disable */
import React, {PropTypes} from 'react';
import ConfigD from './util/ConfigD';
import { Link } from 'react-router';

const MenuInicio = (props) =>{
    if(!(window.location.hostname === 'www.sac.sebrae.com.br')){
        return  <li><a href="https://www.sebrae.com.br/sites/PortalSebrae/ouvidoriasebrae" className="sf-with-ul">Inicio</a></li>
    }else{
        return (null);

    }

}
export default MenuInicio;



/** WEBPACK FOOTER **
 ** ./src/components/MenuInicio.js
 **/